var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-bg page"},[_c('SubHeader',{attrs:{"title":_vm.headerTitle}}),_c('OrderTags',{attrs:{"status":_vm.status}}),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }